import { useNavigate, Routes, Route, useLocation, matchPath } from 'react-router-dom';
import { Page, Header, icons } from 'daymap-library';
import Logo, { SchoolLogo } from '../../components/Logo/Logo';
import Records from './Records/Records';
import Record from './Record/Record';
import { useApp } from '../../helpers/appContext';
import { useAuth } from '../../helpers/authContext';
import { useEffect, useState } from 'react';
import Settings from '../Settings/Settings';
import StudentCodeEntry from '../../components/Containers/StudentCodeEntry';
import styles from './Kiosk.module.scss';

function Kiosk() {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOutMenu } = useAuth();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const { setAppType, setMode, kioskHeader, setStudent, setKioskHeader } = useApp();

  useEffect(() => {
    setStudent(null);
    setKioskHeader(null);
  }, [])

  useEffect(() => {
    if (location.pathname.endsWith('/records') || location.pathname.endsWith('/kiosk'))
      setKioskHeader(null);
  }, [location.pathname])

  const menuClicked = item => {
    switch (item.text) {
      case 'Change Mode': {
        setAppType(null);
        setMode(null);
        navigate('/');
        break;
      }
      case 'Settings': {
        setSettingsOpen(true);
        break;
      }
      default: {}
    }
  }

  const studentFound = student => {
    setStudent(student);
    navigate('/kiosk/records')
  }

  let onBackButtonClick = !matchPath('/kiosk', location.pathname) ? () => navigate(-1) : null;

  let pageTitle = <Logo />
  if (kioskHeader)
        pageTitle = kioskHeader;

  const backgroundStyle = {
        backgroundImage: `url(${SchoolLogo()})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'right'
  };

  return (
    <Page hasHeader center style={backgroundStyle}>
      {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
      <Header title={pageTitle} onMenuItemClick={menuClicked}  onBackButtonClick={onBackButtonClick} menus={signOutMenu && [ signOutMenu ]} />
      <Routes>
        <Route path="/" element={<KioskHome onStudentFound={studentFound} />} />
        <Route path="/records" element={<Records/>} />
        <Route path="/records/:formId" element={<Record/>} />
        <Route path="/records/:formId/:rowIdParam" element={<Record/>} />
      </Routes>
    </Page>
  )
}

function KioskHome({onStudentFound}) {
  return <div className={styles.KioskHome}>
    <SchoolLogo />
    <StudentCodeEntry onStudentFound={onStudentFound} />
  </div>
}

export default Kiosk;